export default __webpack_public_path__ + "static/media/client_13.74c72aad.png";